import styled from "styled-components";

import { Input as UnstyledInput } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import {
  getFontFamily,
  // getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const CheckboxLabel = styled.label`
  align-items: center;
  color: ${({
    theme: {
      colors: { grey },
    },
  }) => grey};
  display: inline-flex;
  flex-flow: row nowrap;
  font-size: 14px;
  line-height: 22px;
  padding: 0px;
  text-align: left;
  @media screen and (min-width: ${getSize(
      "tablet960"
    )}) and (max-width: 1199px) {
    font-size: 20px;
    line-height: 31px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    font-size: 20px;
    line-height: 31px;
  }
  ${getFontFamily("regular")}
`;

export const CheckboxInput = styled(UnstyledInput)`
  + div {
    align-self: start;
    flex-shrink: 0;
    margin: 4px 16px 0px 0px;
  }
  :disabled + div + span {
    color: ${({
      theme: {
        colors: { lightGrey },
      },
    }) => lightGrey};
  }
`;
